import { AppConstants } from "../../../../core/constants/constants";
import { Partner } from "../../domain/entities/Partner";
import { PartnerPending } from "../../domain/entities/partnerPending";
import { PartnerSocketRepository } from "../../domain/repositories/PartnerSocketRepository";
import { PartnerSocketDataSource } from "../datasource/PartnerSocketDataSource";

export class PartnerSocketRepositoryImpl implements PartnerSocketRepository {
    constructor(private dataSource: PartnerSocketDataSource) {}

    getSocket(){
        return this.dataSource.getSocket()
    }
    connectPartnerSocket(): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.connectPartnerSocket()
        );
    }
    
    disconnectPartnerSocket(): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.disconnectPartnerSocket()
        );
    }
    
    getPendingPartners(): Promise<PartnerPending[]> {
        return AppConstants.getRightOrLeftSide<PartnerPending[]>(
            this.dataSource.getPendingPartners()
        );
    }
    
    cancelInvitationPartner(user_id: string): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.cancelInvitationPartner(user_id)
        );
    }
    deleteCurrentPartner(user_id: string): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.deleteCurrentPartner(user_id)
        );
    }

    sendInvitationPartner(id:string,user_id: string, match_id: string): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.sendInvitationPartner(id,user_id, match_id)
        );
    }

    responseInvitation(user_id: string, partner_response: boolean): Promise<void> {
        return AppConstants.getRightOrLeftSide<void>(
            this.dataSource.responseInvitation(user_id, partner_response)
        );
    }


    getNotificationsPartner(
        callback: (data: PartnerPending) => void
    ): void {
        this.dataSource.getNotificationsPartner(callback)
    }

    getNotificationsPartnerResponse(
        callback: (data: any) => void
    ): void {
        this.dataSource.getNotificationsPartnerResponse(callback)
    }

    listenPartnerInvited(
        callback: (data: Partner) => void
    ): void {
       this.dataSource.listenPartnerInvited(callback)
    }
}
